import React, { useEffect } from "react";
import { useState } from "react";
import { useAlert } from "react-alert";
import { Carousel, Modal } from "react-bootstrap";
import "../assets/css/newRegistration.css";
import api from "../seller-apis/api";
import axios from "axios";
import { stateArray } from "../utilities/stateJson";
import { filterOrdersfilter } from "../seller-apis/apidataField";
import { verifyToken } from "../utilities/checkToken";
import { useHistory } from "react-router-dom";
import RegistrationStepper from "./Registration/RegistrationStepper";

const HEAR_ABOUT_OPTIONS = [
  "Google",
  "Facebook",
  "LinkedIn",
  "Refer by other seller",
  "Contacted by agent",
];

const ECOMMERCE_VOLUME_OPTIONS = [
  "Below ₹1 lakh",
  "₹1 - ₹5 lakh",
  "Above ₹5 lakh",
];

const NewLeads = () => {
  const alert = useAlert();

  // sl-804
  const [remark, setRemark] = useState("");
  const [hearAboutUs, setHearAboutUs] = useState("");
  const [city, setCity] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("");
  const [mobile, setMobile] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [tag, setTag] = useState("");
  const [tags, setTags] = useState([]);
  const [ecommerceSite, setEcommerceSite] = useState("no");
  const [ecommerceSiteData, setEcommerceSiteData] = useState("");
  const [ecommerceVolume, setEcommerceVolume] = useState("");
  const [whatsappUpdate, setWhatsappUpdate] = useState(false);
  const [modalShow, setModalHideShow] = useState(false);
  const [errors, setErrors] = useState([]);
  const [showValidation, setShowValidation] = useState(false);
  const [serverMSG, setServerMSG] = useState(null);
  const [otpShow, setOtpShow] = useState(false);
  const [resDone, setResDone] = useState(false);
  const [timer, setTimer] = useState(0);
  const [resendOtpDiv, setresendOtpDiv] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [otp, setOTP] = useState("");

  // */ sl- 821
  const [leadId, setLeadId] = useState(null);
  // sl-821 /*
  const history = useHistory();
  const validateEmail = (email) => {
    // Regular expression pattern for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  // Example usage
  // const token = 'your_jwt_token_here';

  const updateSellerLocalStorage = (seller = {}) => {
    localStorage.setItem('name', seller.name);
    localStorage.setItem('image', seller.avatar);
    localStorage.setItem('phone', seller.phoneNumber)
    localStorage.setItem('userId', seller._id)
    localStorage.setItem('email', seller.email)
    localStorage.setItem("vendorId", seller._id)
    localStorage.setItem('gst', seller.gstNo)
    localStorage.setItem('vendorType', seller.vendorType ? seller.vendorType : undefined)
    localStorage.setItem('vendorState', seller.activeState)
  }

  useEffect(() => {
    let isMounted = true;
    const token = localStorage.getItem("token");

    const refreshSellerAndRedirect = async () => {
      if (!token || !verifyToken(token)) {
        return;
      }

      try {
        const res = await api.auth.me({});
        if (!isMounted) {
          return;
        }

        if (res?.data) {
          updateSellerLocalStorage(res.data);
        }

        if (res?.message === "Seller Not Found") {
          localStorage.clear();
          return;
        }

        history.push("/home");
      } catch (err) {
        console.log(err);
      }
    };

    refreshSellerAndRedirect();

    return () => {
      isMounted = false;
    }
  }, []);
  const addTags = (event) => {
    if (event.key === "Enter") {
      if (tags.length < 10) {
        if (event.target.value.trim() != "") {
          let tempTags = event.target.value.trim().split(",");
          setTags([...tags, ...tempTags]);
          setTag("");
        }
      } else {
        alert.show("You can add 10 Products only", {
          type: "info",
        });
      }
      event.target.value = "";
    }
  };

  const updateEcommerceSite = (e) => {
    if (e.target.value == 1) {
      setEcommerceSite("yes");
    } else {
      setEcommerceSite("no");
      setEcommerceSiteData("");
      setEcommerceVolume("");
    }
  };

  function callPincode(e) {
    console.log("Hello callPincode");
    axios
      .get(`https://api.postalpincode.in/pincode/${e}`)
      .then((res) => res.data[0])
      .then((res) => {
        if (res.PostOffice.length > 0) {
          setState(res.PostOffice[0].State);
          setCity(res.PostOffice[0].District);
        }
      })
      .catch((err) => console.log(err));
  }

  function resetForm() {
    // setMobile("");
    setEmail("");
    setCompanyName("");
    setPinCode("");
    setState("");
    setCity("");
    setTag("");
    setTags([]);
    setEcommerceSiteData("");
    setEcommerceVolume("");
    setEcommerceSite("no");
    setWhatsappUpdate(false);
    setRemark("");
    setHearAboutUs("");
  }
  useEffect(() => {
    checkValidation();
  }, [mobile, companyName, pinCode, state, tag, city, email, ecommerceSite, ecommerceSiteData, ecommerceVolume, remark, hearAboutUs]);
  function checkValidation() {
    setValidEmail(false);
    let tempErrors = [];
    const zipRegex = new RegExp("^[1-9]{1}[0-9]{2}[0-9]{3}$");
    if (mobile === "" || mobile === undefined || mobile.length < 10) {
      tempErrors.push("mobile");
      setServerMSG(null);
    }
    if (email === "" || email === undefined || email.trim() === "") {
      tempErrors.push("email");
    } else if (!validateEmail(email)) {
      tempErrors.push("emailValid");
      setValidEmail(true);
    }
    if (companyName === "" || companyName === undefined || companyName.trim() === "") {
      tempErrors.push("company");
    }
    if (pinCode === undefined || pinCode === "" || !zipRegex.test(pinCode)) {
      tempErrors.push("zip");
    }
    if (state === undefined || state === "") {
      tempErrors.push("state");
    }
    if (city === undefined || city === "" || city.trim() === "") {
      tempErrors.push("city");
    }
    // if (tag == "" && tags.length == 0 && tag.trim() == "") {
    //   tempErrors.push("key");
    // }
    if (remark === "" || remark === undefined || remark === null || remark.trim() === "") {
      tempErrors.push("remark");
    }
    if (!hearAboutUs) {
      tempErrors.push("hearAboutUs");
    }
    if (ecommerceSite == "yes" && ecommerceSiteData == "") {
      tempErrors.push("ecom");
    }
    if (ecommerceSite == "yes" && !ecommerceVolume) {
      tempErrors.push("ecomVolume");
    }
    setErrors([...tempErrors]);
    return tempErrors;
  }

  const startTimer = () => {
    setresendOtpDiv(false);
    var timerId = setInterval(countdown, 1000);
    let timeLeft = 11;
    function countdown() {
      if (timeLeft === 0) {
        clearTimeout(timerId);
        setresendOtpDiv(true);
        setTimer("00");
      } else {
        timeLeft--;
        setTimer(timeLeft);
      }
    }
  };

  async function saveVendorLeads() {

    setShowValidation(true);
    setServerMSG(null);
    // let tempTags = [];
    // let allTags = [...tags];
    // if (tag != "") {
    //   tempTags = tag.split(",");
    //   setTags([...tags, ...tempTags]);
    //   allTags.push(...tempTags);
    //   setTag("");
    // }
    let errors = checkValidation();
    // if (tempTags.length > 10) {
    //   alert.show("You can add 10 Products only", {
    //     type: "info",
    //   });
    // }
    if (errors.length == 0) {
      setShowValidation(false);
      let data = {
        phoneNumber: mobile,
        companyName: companyName.trim(),
        pincode: pinCode,
        email: email.trim(),
        city: city.trim(),
        state: state,
        // keyProducts: allTags,
        ecommerceSite: ecommerceSite,
        ecommerceSiteData: ecommerceSiteData,
        ecommerceVolume: ecommerceVolume,
        whatsappUpdate: whatsappUpdate,
        remark: remark,
        hearAboutUs: hearAboutUs,
        platform: "Desktop"
      };
      api.auth
        .saveVendorLead(data)
        .then((res) => {
          if (res.data.message === "Record updated ") {
            // localStorage.setItem("token", res.data.token)
            // resetForm();
            setLeadId(res.data?.data?._id);
            startTimer();
            setOtpShow(true);
            // setModalHideShow(true);
            // alert.success(
            //   "Thank you for showing interest to sell your products on Toolsvilla. We have received your request. Our Team will contact you soon"
            // );
          } else {
            // alert.info(res.data.message);
            setServerMSG(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  const [otpError, setOtpError] = useState("");
  const [otpButDisable, setOtpButDisable] = useState(true);

  const buttonCheck = (e) => {
    if (e.target.value.length != 4) {
      setOtpButDisable(true);
      setOtpError("Please enter a valid otp");
    } else {
      setOtpButDisable(false);
      setOtpError("");
    }
  };
  const verifyOTP = (e, data = otp) => {
    if (e.keyCode == 13) {
      if (data == "") {
        setOtpError("Please enter otp");
      } else if (data.length != 4) {
        setOtpButDisable(true);
        setOtpError("Please enter a valid otp");
      } else {
        let param = {
          phoneNumber: mobile,
          otp: data,
          data: leadId,
        };
        if (leadId === null) {
          alert.error("Error");
          return;
        }
        api.auth
          .VerifyVendorLead(param)
          .then((data) => {
            console.log(data);
            if (data.data.message == "Enter Correct OTP") {
              setOtpError(data.data.message);
            } else if (data.data.message == "Verified") {
              localStorage.setItem("lead", leadId);
              history.push('/register/step2')
            } else {
              setOtpError(data.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  return (
    <>
      <div className="new_Registration_Cntn">
        {/* Header */}
        <div className="n_Reg_Header d-flex" id="first_panel">
          <div className="n_Reg_Header_logo w-50">
            <img className="" src="./reg_header_logo.png" alt="img"></img>
          </div>
          <div className="n_Reg_Header_buttons w-50 m-auto">
            <button
              className="n_Reg_Header_buttons_ft"
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.toolsvilla.seller",
                  "_blank"
                )
              }
            >
              <i className="fa fa-mobile me-1" aria-hidden="true"></i> Download
              App
            </button>
            <button
              className="n_Reg_Header_buttons_ft"
              onClick={() => window.location.assign("/login")}
            >
              <i className="fa fa-user me-1" aria-hidden="true"></i> Log In
            </button>
            <button className="n_Reg_Header_buttons_lb">Seller Support</button>
          </div>
        </div>

        {/* 1 section */}
        <div
          className={
            tags.length > 0
              ? "n_Reg_first_cntn leads-form-with-tag form-bg dis-flex"
              : "n_Reg_first_cntn leads-form  form-bg dis-flex"
          }
        >
          {!otpShow ? (
            <div
              className={
                tags.length > 0
                  ? "n_Reg_first_form leads-form-height-with-tag"
                  : "n_Reg_first_form leads-form-height"
              }
            >
              <div className="lead_form_head">
                <h4 className="">Join as a Seller Now!</h4>
                {/* <h6>Create your account now</h6> */}
              </div>
              <div className="n_Reg_first_form_input mtm-16">
                <span className="">+ 91 |</span>
                <input
                  type="number"
                  className="n_Reg_first_form_input_m_no"
                  placeholder="Mobile No*"
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
                {showValidation && errors.includes("mobile") && (
                  <p className="lead-error">Please enter a valid Mobile no.</p>
                )}
                <input
                  type="text"
                  placeholder="Company Name*"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
                {showValidation && errors.includes("company") && (
                  <p className="lead-error">Please enter Company Name.</p>
                )}
                <input
                  type="text"
                  placeholder="Email*"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {showValidation && errors.includes("email") && (
                  <p className="lead-error">Please enter email.</p>
                )}
                {validEmail && errors.includes("emailValid") && (
                  <p className="lead-error">Please enter a valid email.</p>
                )}
              </div>
              <div className="d-flex n_Reg_first_form_input two-input-row">
                <div className=" n_Reg_first_form_input">
                  <input
                    type="number"
                    placeholder="Enter Pincode"
                    onChange={(e) => {
                      if (e.target.value.length < 7) {
                        setPinCode(e.target.value);
                        if (e.target.value.length === 0) {
                          setState("");
                          setCity("");
                        }
                        if (e.target.value.length === 6) {
                          callPincode(e.target.value);
                        }
                      }
                    }}
                    value={pinCode}
                    onWheel={(e) => e.target.blur()}
                  />
                  {showValidation && errors.includes("zip") && (
                    <p className="lead-error">
                      Please enter a valid zip/postal code
                    </p>
                  )}
                </div>
                <div className=" n_Reg_first_form_input">
                  <input
                    type="text"
                    placeholder="City"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                  {showValidation && errors.includes("city") && (
                    <p className="lead-error">Please choose your city</p>
                  )}
                </div>
              </div>
              <div className="n_Reg_first_form_input">
                <select
                  type="text"
                  placeholder="State*"
                  onChange={(e) => setState(e.target.value)}
                  value={state}
                >
                  <option value="">State*</option>
                  {stateArray.map((state, i) => {
                    return (
                      <option value={state} key={i}>
                        {state}
                      </option>
                    );
                  })}
                </select>
                {showValidation && errors.includes("state") && (
                  <p className="lead-error">Please choose your state</p>
                )}
              </div>

              {/* I1-3061 */}
              {/* <div className="n_Reg_first_form_input">
                <input
                  type="text"
                  placeholder="Key Products"
                  value={tag}
                  onKeyPress={(e) => addTags(e)}
                  onChange={(e) => setTag(e.target.value)}
                />
                {showValidation && errors.includes("key") && (
                  <p className="lead-error">Please add key products</p>
                )}
                {tags.length > 0 && (
                  <div className="tags-container">
                    <div className="tags-inner">
                      {tags.map((tag, index) => {
                        return (
                          <div key={index} className="tag">
                            {tag}
                            <button
                              className="tag-close"
                              onClick={() => {
                                setTags(
                                  tags.filter(
                                    (item, index1) => index1 !== index
                                  )
                                );
                              }}
                            >
                              &times;
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                <p className="key-msg">(Press Enter or comma separated)</p>
              </div> */}

              {/* sl-804 */}
              <div className=" n_Reg_first_form_input">
                <textarea
                  placeholder="Please add your remarks here*"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
                {showValidation && errors.includes("remark") && (
                  <p className="lead-error">Please enter a valid remark</p>
                )}
              </div>
              <div
                className={`n_Reg_hear-about-field${
                  showValidation && errors.includes("hearAboutUs")
                    ? " n_Reg_hear-about-field--error"
                    : ""
                }`}
              >
                <label className="n_Reg_hear-about-label" htmlFor="hearAboutUs">
                  How did you hear about us?
                  <span className="n_Reg_hear-about-required">*</span>
                </label>
                <div className="n_Reg_hear-about-select-wrap">
                  <select
                    id="hearAboutUs"
                    className={`n_Reg_hear-about-select${
                      !hearAboutUs ? " n_Reg_hear-about-select--placeholder" : ""
                    }`}
                    value={hearAboutUs}
                    onChange={(e) => setHearAboutUs(e.target.value)}
                  >
                    <option value="">Select</option>
                    {HEAR_ABOUT_OPTIONS.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  <i className="bi bi-chevron-down n_Reg_hear-about-chevron" aria-hidden="true" />
                </div>
                {showValidation && errors.includes("hearAboutUs") && (
                  <p className="n_Reg_hear-about-error" role="alert">
                    Please select an option.
                  </p>
                )}
              </div>
              <div className="n_Reg_first_form_radio">
                <div className="selling-on-other">
                  Are you selling on other eCommerce portals?
                </div>
                <div
                  className={`input-radio ecommerce-yes-row${
                    ecommerceSite === "yes" ? " ecommerce-yes-row--expanded" : ""
                  }`}
                >
                  <div className="ecommerce-yes-option">
                    <input
                      type="radio"
                      value="1"
                      name="radio-ecommerce"
                      id="radio-yes"
                      checked={ecommerceSite === "yes"}
                      onChange={(e) => updateEcommerceSite(e)}
                    />
                    <label htmlFor="radio-yes">Yes</label>
                  </div>
                  {ecommerceSite === "yes" && (
                    <div className="ecommerce-fields-row">
                      <input
                        className="ecommerce-data-input"
                        type="text"
                        name="ecommerce-data"
                        placeholder="Please specify here"
                        value={ecommerceSiteData}
                        onChange={(e) => setEcommerceSiteData(e.target.value)}
                      />
                      <div className="ecommerce-volume-select-wrap">
                        <select
                          className={`ecommerce-volume-select${
                            !ecommerceVolume
                              ? " ecommerce-volume-select--placeholder"
                              : ""
                          }`}
                          value={ecommerceVolume}
                          onChange={(e) => setEcommerceVolume(e.target.value)}
                        >
                          <option value="">Select Volume</option>
                          {ECOMMERCE_VOLUME_OPTIONS.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <i
                          className="bi bi-chevron-down ecommerce-volume-chevron"
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                  )}
                </div>
                {showValidation && errors.includes("ecom") && (
                  <p className="error ecom-validation">
                    Please add Ecommerce Portal links
                  </p>
                )}
                {showValidation && errors.includes("ecomVolume") && (
                  <p className="error ecom-validation">
                    Please select sales volume
                  </p>
                )}

                <div className="input-radio ecommerce-no-option">
                  <input
                    type="radio"
                    name="radio-ecommerce"
                    value="0"
                    id="radio-no"
                    checked={ecommerceSite === "no"}
                    onChange={(e) => updateEcommerceSite(e)}
                  />
                  <label htmlFor="radio-no">No</label>
                </div>
              </div>
              <div className="n_Reg_first_form_foot">
                <input
                  type="checkbox"
                  id="n_Reg_first_checkboxid"
                  className="mt-2 n_Reg_first_checkbox"
                  onChange={(e) => setWhatsappUpdate(e.target.checked)}
                ></input>
                <label
                  className="ms-2 fs-14 n_Reg_first_label"
                  for="n_Reg_first_checkboxid"
                >
                  I want to receive important updates on Whatsapp
                </label>
                {serverMSG && (
                  <p className="server-error">
                    {/* {serverMSG} */}
                    {serverMSG}
                  </p>
                )}
                <button onClick={() => saveVendorLeads()}>
                  Create Account
                </button>
              </div>
            </div>
          ) : (
            <div className="rotpbox">
              {!resDone ? (
                <div>
                  <div className="heading">
                    Submit OTP to complete your request
                  </div>
                  <div>
                    <div class="otp-title">Enter OTP</div>
                    <div class="otp-container">
                      <span>Sent to : </span>
                      <p>+91 {mobile}</p>
                    </div>
                    <div class="otp-container">
                      <input
                        type="text"
                        class="otp-input w-100"
                        value={otp}
                        onChange={(e) => {
                          setOTP(e.target.value);
                          buttonCheck(e);
                        }}
                        onKeyUp={(e) => verifyOTP(e, e.target.value)}
                      />
                    </div>
                    <div class="text-danger fs-12">{otpError}</div>
                    <div style={{ padding: "10px", textAlign: "center" }}>
                      <div class="resend-otp text-center">
                        {"00:" + timer}{" "}
                        {resendOtpDiv ? (
                          <strong
                            onClick={() => saveVendorLeads()}
                            className="cursor-pointer"
                          >
                            Resend OTP
                          </strong>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div class="text-center">
                      <button
                        disabled={otpButDisable}
                        class="profile-but"
                        onClick={() => verifyOTP({ keyCode: 13 })}
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="res-done">
                  <div>
                    <img src="/step-done.webp" alt="icon" />
                  </div>
                  <div>
                    Your account registration is received by us ,Our team will
                    contact you soon.
                  </div>
                </div>
              )}
            </div>
          )}
          {/* <img src="./registration_2.png" className="" alt="img"></img> */}
        </div>

        {/* 2 section */}
        <div className="n_Reg_second_cntn restration-desk">
          <img src="./registration_1.png" className="" alt="img"></img>
        </div>
        <div
          className="n_Reg_second_cntn  restration-mob"
          style={{ display: "none" }}
        >
          <img src="./registration_1_mob.png" className="" alt="img"></img>
        </div>

        {/* 3 section */}
        <div className="n_Reg_third_cntn">
          <div className="n_Reg_third_first">
            <div className="">
              <p> 6 Simple Steps </p>
              <p> to Start Your Business</p>
            </div>
            <div className="down-arrow"> <img src="./arrow-down.png" /></div>
          </div>
          <div className="n_Reg_third_cards_cntn">
            <div className="n_Reg_third_cards">
              <img src="./r_des_3card_1.png" alt="img"></img>
            </div>
            <div className="n_Reg_third_cards">
              <img src="./r_des_3card_2.png" alt="img"></img>
            </div>
            <div className="n_Reg_third_cards">
              <img src="./r_des_3card_3.png" alt="img"></img>
            </div>
            <div className="n_Reg_third_cards">
              <img src="./r_des_3card_4.png" alt="img"></img>
            </div>
            <div className="n_Reg_third_cards">
              <img src="./r_des_3card_5.png" alt="img"></img>
            </div>
            <div className="n_Reg_third_cards">
              <img src="./r_des_3card_6.png" alt="img"></img>
            </div>
          </div>
        </div>

        {/* 4 section */}
        <div className="n_Reg_fourth_cntn">
          <div className="">What makes sellers love Toolsvilla</div>
          <div className="n_Reg_fourth_card_cntn">
            <Carousel
              className="my-4 carousel text-center  restration-desk"
              pause="hover"
              
            >
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review1.png" alt="img"></img>
                <img src="./reg_review2.png" alt="img"></img>
                <img src="./reg_review3.png" alt="img"></img>
              </Carousel.Item>
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review4.png" alt="img"></img>
                <img src="./reg_review5.png" alt="img"></img>
                <img src="./reg_review6.png" alt="img"></img>
              </Carousel.Item>
            </Carousel>
            <Carousel
              className="my-4 carousel text-center restration-mob"
              pause="hover"
            >
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review1.png" alt="img"></img>
              </Carousel.Item>
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review2.png" alt="img"></img>
              </Carousel.Item>
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review3.png" alt="img"></img>
              </Carousel.Item>
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review4.png" alt="img"></img>
              </Carousel.Item>
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review5.png" alt="img"></img>
              </Carousel.Item>
              <Carousel.Item className="home_carousel_cntn">
                <img src="./reg_review6.png" alt="img"></img>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>

        {/* 5 section */}
        <div className="n_Reg_fifth_cntn">
          <div className="row">
            <div className="col-4">
              <div className="d-flex m-auto">
                <div className="n_Reg_fifth_foot_logo">
                  <img src="./logo-search.png" alt="image" />
                </div>
                <div className="n_Reg_fifth_foot_logo_text">
                  <span className="n_Reg_fifth_foot_logo_text_1">
                    TOOLSVILLA
                  </span>
                  <br></br>
                  <span className="n_Reg_fifth_foot_logo_text_2">
                    Sell on India’s leading B2B E-commerce Marketplace
                  </span>
                </div>
              </div>
              <div className="n_Reg_fifth_cntn_logo_btn">
                <button
                  onClick={() =>
                    document.getElementById("first_panel").scrollIntoView()
                  }
                >
                  START SELLING
                </button>
              </div>
            </div>
            <div className="col-1">
              {/* <p className='n_Reg_fifth_heading'>Quick Links</p>
                <ul className='n_Reg_fifth_ul n_Reg_fifth_ul_quicklinks'>
                    <li><NavLink exact to="/">Login</NavLink></li>
                    <li><NavLink exact to="/">How it works</NavLink></li>
                    <li><NavLink exact to="/">Shipping & Returns</NavLink></li>
                    <li><NavLink exact to="/">Terms & Conditions</NavLink></li>
                    <li><NavLink exact to="/">Privacy Policy</NavLink></li>
                    <li><NavLink exact to="/">Learning centre</NavLink></li>
                </ul> */}
            </div>
            <div className="col-4">
              <p className="n_Reg_fifth_heading">Contact</p>
              <ul className="n_Reg_fifth_ul n_Reg_fifth_ul_contacts">
                <li>
                  <a href="mailto:sellersupport@toolsvilla.com">
                    sellersupport@toolsvilla.com
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-3 d-flex justify-content-center">
              <div className="n_Reg_fifth_cntn_social_icons">
                <img
                  src="./yt_rg_icon.png"
                  alt="image"
                  onClick={() =>
                    window.open(
                      " https://www.youtube.com/@toolsvilla_tv",
                      "_blank"
                    )
                  }
                />
              </div>
              <div className="n_Reg_fifth_cntn_social_icons">
                <img
                  src="./fb_rg_icon.png"
                  alt="image"
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/toolsvilla/",
                      "_blank"
                    )
                  }
                />
              </div>
              <div className="n_Reg_fifth_cntn_social_icons">
                <img
                  src="./in_rg_icon.png"
                  alt="image"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/toolsvilla/?hl=en",
                      "_blank"
                    )
                  }
                />
              </div>
              {/* <div className='n_Reg_fifth_cntn_social_icons'>
                    <img src='./li_rg_icon.png' alt='image' onClick={() => window.open("https://www.facebook.com/toolsvilla/", "_blank")} />
                </div> */}
            </div>
          </div>
          <div className="n_Reg_fifth_cntn_copyright">
            <p>Copyright @2022 toolsvilla</p>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={() => setModalHideShow(false)}
      >
        <Modal.Body className="m-1 text-center success-body">
          <div
            className="modal-close"
            onClick={() => {
              console.log("sd");
              setModalHideShow(false);
            }}
          >
            &#10006;
          </div>
          <div>
            <img src="./checked.png" alt="success-icon" />{" "}
          </div>
          <h5 className="ff_Pop_first">Thank you for showing interest !</h5>
          <h5 className="ff_Pop">
            We have received your request. Our Team will contact you soon.
          </h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewLeads;
